import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Row, Col } from 'antd';
import Translate from 'react-translate-component';

import { setNotificationPermission } from 'actions/notificationActions';

@connect(null, { setNotificationPermission })
export default class CustomPushPermissionModal extends Component {
    render() {
        const { setNotificationPermission } = this.props;

        return (
            <Modal
                visible={true}
                width={400}
                title={<Translate content="modal.enable_push" />}
                mask={false}
                maskClosable={false}
                wrapClassName="removed-modal-wrap"
                className="push-confirm-modal"
                footer={false}
                onCancel={() => {
                    setNotificationPermission(false);
                }}
            >
                <Row gutter={15}>
                    <Col span={12}>
                        <Button onClick={() => {
                            setNotificationPermission(false);
                        }}>
                            <Translate content="modal.deny" />
                        </Button>
                    </Col>
                    <Col span={12}>
                        <Button type="blue" onClick={() => {
                            setNotificationPermission(true);
                        }}>
                            <Translate content="modal.enable" />
                        </Button>
                    </Col>
                </Row>
            </Modal>
        );
    }
}
